import { useCallback, useState } from 'react'
import { Integration } from '@playbooks/action-cards-utils'

import { useAppContext } from '../contexts/AppContext'

const authBinInitialState = { text: '', isVisible: false }

function useHandleIntegrationAuth(integration: Integration) {
  const [authBtn, setAuthBtn] = useState(authBinInitialState)
  const [isProcessing, setIsProcessing] = useState(false)

  const { config } = useAppContext()

  function showAuthBtn(text: string) {
    setAuthBtn({ text, isVisible: true })
  }

  function hideAuthBtn() {
    setAuthBtn(authBinInitialState)
  }

  const handleAuth = useCallback(async () => {
    setIsProcessing(true)

    try {
      await config?.connectIntegration?.(integration)

      hideAuthBtn()
    } catch (error) {
      console.error('[handleAuth]:', error)
    }

    setIsProcessing(false)
  }, [config, integration])

  return { authBtn, showAuthBtn, hideAuthBtn, isProcessing, handleAuth }
}

export default useHandleIntegrationAuth
